export default __webpack_public_path__ + "static/media/Whatsapp.17ad5953.svg";